import React from "react";

export default function Services() {
  return (
    <section className="skills-section style-2" id="skills-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-header style-2 text-center">
              <h2 className="section-title wow fadeInUp" data-wow-delay=".3s">
                Skills
              </h2>
              <p className="wow fadeInUp" data-wow-delay=".4s" >
             As a Full Stack Developer,
              I build digital experiences that connect design and logic.
        My work is all about clarity, performance, and creating web solutions that feel effortless — both 
        for users and developers.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="skills-widget style-2 d-flex flex-wrap justify-content-center align-items-center">

  
              <div className="skill-item wow fadeInUp" data-wow-delay=".3s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="assets\img\icons\python-svgrepo-com.svg" alt="python" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Python</p>
              </div>


              <div className="skill-item wow fadeInUp" data-wow-delay=".4s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="assets\img\icons\django.svg" alt="Django" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Django</p>
              </div>

        
              <div className="skill-item wow fadeInUp" data-wow-delay=".5s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="assets\img\icons\fastapi.svg" alt=" Fastapi" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>FastApi </p>
              </div>

              <div className="skill-item wow fadeInUp" data-wow-delay=".6s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="assets\img\icons\rest-api.svg" alt="RESTAPI" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>RestApi</p>
              </div>

        
              <div className="skill-item wow fadeInUp" data-wow-delay=".7s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/docker.svg" alt="docker" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Docker</p>
              </div>


              <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/redis.svg" alt="Redis" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Redis</p>
              </div>

              <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/react.svg" alt="React" />
                  </div>
                  <div className="number">90%</div>
                </div>
                <p>React</p>
              </div>

              <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/postman.svg" alt="postman" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Postman</p>
              </div>

              <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/linux.svg" alt="linux" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Linux</p>
              </div>

              <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/mysql.svg" alt="mysql" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Mysql</p>
              </div>

              <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/github.svg" alt="github" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Github</p>
              </div>

         <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/figma.svg" alt="figma" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Figma</p>
              </div>


         <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/bootstrap.svg" alt="bootstarp" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Bootstrap</p>
              </div>


         <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/html.svg" alt="html" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Html</p>
              </div>
      <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/css.svg" alt="css" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Css</p>
              </div>


         <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/js.svg" alt="js" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Js</p>
              </div>

         <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/php.svg" alt="php" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Php</p>
              </div>

         <div className="skill-item wow fadeInUp" data-wow-delay=".8s">
                <div className="skill-inner">
                  <div className="icon-box">
                    <img src="/assets/img/icons/wordpress.svg" alt="wordpress" />
                  </div>
                  <div className="number">100%</div>
                </div>
                <p>Wordprees</p>
              </div>

   
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
